import React, { useState } from "react"

function GarryReactComponent() {
  const [clickCount, setClickCount] = useState(0)

  return (
    <div className="example-react-component" onClick={() => setClickCount(prev => prev + 1)}>
      <h1>Hello from React again and again boom boom!</h1>
      <p>You have clicked on this component {clickCount} times.</p>
    </div>
  )
}

export default GarryReactComponent